import React from 'react';

import { StringDisplay } from '../../Fields';
import { StringReadOnlyViewProps } from '../types';

export const ExpenseTypeFunnelReadOnlyView = (props: StringReadOnlyViewProps) => <StringDisplay {...props} />;
